export const WinRate = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.82494 4.99997H10.0649C11.4949 4.99997 12.4649 6.46997 11.9049 7.78997L9.76494 12.79C9.44494 13.52 8.72494 14 7.92494 14H2.00494C0.904944 14 0.00494385 13.1 0.00494385 12V6.20997C0.00494385 5.67997 0.214944 5.16997 0.604944 4.79997L4.60494 0.799971C5.03494 0.359971 5.74494 0.359971 6.18494 0.799971C6.44494 1.06997 6.56494 1.44997 6.48494 1.81997L5.82494 4.99997ZM16.0849 9.99997H22.0049C23.1049 9.99997 24.0049 10.9 23.9949 12V17.79C23.9949 18.32 23.7849 18.82 23.4049 19.2L19.4049 23.2C18.9749 23.64 18.2649 23.64 17.8249 23.2C17.5649 22.93 17.4449 22.55 17.5249 22.18L18.1849 19H13.9449C12.5049 19 11.5449 17.53 12.1049 16.21L14.2449 11.21C14.5649 10.48 15.2849 9.99997 16.0849 9.99997Z"
    />
  </svg>
);
